module.exports = __webpack_public_path__ + "img/julien-clerc.ea49b9a2.jpg";